import type { ColumnConfig } from '../../../hooks/useColumnConfig';
import { ONE_ON_ONE_TYPE_LABELS } from '../../../types';

// MDF-253: column ids match the API row fields, which are also the export keys.
export const ONE_ON_ONE_COLUMNS: ColumnConfig[] = [
  { id: 'participant_name', label: 'Participant', visible: true, sortable: true },
  { id: 'coach_name', label: 'Coach', visible: true, sortable: true },
  { id: 'cohort_name', label: 'Cohort', visible: true, sortable: true },
  { id: 'group_name', label: 'Group', visible: true, sortable: false },
  { id: 'one_on_one_type', label: 'Type', visible: true, sortable: false },
  // MED-1346: the id is the API sort key; the export reads sessionNumber.
  { id: 'session_number', label: '1:1 #', visible: true, sortable: true, exportKey: 'sessionNumber', numericGroups: true },
  { id: 'scheduled_start', label: 'Scheduled', visible: true, sortable: true },
  { id: 'status', label: 'Status', visible: true, sortable: true },
  { id: 'engagement_rating', label: 'Engagement', visible: true, sortable: false },
  { id: 'absent_reason', label: 'Absence Reason', visible: false, sortable: false },
  { id: 'booked_via', label: 'Booked Via', visible: true, sortable: false },
  { id: 'attendance_notes', label: 'Coach Notes', visible: true, sortable: false, groupable: false },
  { id: 'session_notes', label: 'Session Notes', visible: true, sortable: false, groupable: false },
  { id: 'feedback', label: 'Coach Feedback', visible: true, sortable: false, groupable: false },
  // MED-1346: every no-show and late change on this 1:1, with its pay result.
  { id: 'misses', label: 'Missed / rescheduled', visible: true, sortable: false, exportKey: 'misses' },
  { id: 'participant_email', label: 'Participant Email', visible: false, sortable: false, groupable: false },
];

export const ONE_ON_ONE_STATUS_OPTIONS = [
  { value: 'completed', label: 'Completed', color: 'green' },
  { value: 'scheduled', label: 'Scheduled', color: 'blue' },
  { value: 'needs_attendance', label: 'Needs attendance', color: 'orange' },
  { value: 'not_scheduled', label: 'Not scheduled', color: 'gray' },
  // MED-1346: the attendance word; a real no-show shows in "Missed / rescheduled".
  { value: 'absent', label: 'Absent', color: 'red' },
  { value: 'canceled', label: 'Canceled', color: 'dark' },
  { value: 'withdrawn', label: 'Withdrawn', color: 'grape' },
] as const;

/** Status value to label, for the 1:1s and the 1:1 history tabs. */
export const ONE_ON_ONE_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  ONE_ON_ONE_STATUS_OPTIONS.map(o => [o.value, o.label]),
);

/**
 * MED-1346: the Data Library 1:1 type labels. A coach-made general huddle
 * comes as coach_huddle and has no 1:1 number.
 */
export const DATA_LIBRARY_ONE_ON_ONE_TYPE_LABELS: Record<string, string> = {
  ...ONE_ON_ONE_TYPE_LABELS,
  coach_huddle: 'Coach huddle',
};

export const ABSENT_REASON_LABELS: Record<string, string> = {
  business_conflict: 'Business conflict',
  personal_conflict: 'Personal conflict',
  no_notice: 'No notice',
};
